import { useTheme } from "../components/Theme";
export default function Calendario({ onAbrirLead }) {
  const { theme } = useTheme();
  return (
    <div style={{ padding:40, textAlign:"center", color:theme.textMuted, fontFamily:"'Inter',sans-serif" }}>
      <div style={{ fontSize:40, marginBottom:12 }}>📅</div>
      <p>Calendário em breve</p>
    </div>
  );
}
